import { RootState } from '../../applicationStore';
import { GlobalErrorsState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getGlobalErrorsState = (state: RootState): GlobalErrorsState =>
  state.globalErrors;

export const getGlobalErrorsData = createSelector(
  getGlobalErrorsState,
  (state): GlobalErrorsState['data'] => state?.data,
);
